unit View.Csosn.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewCsosnList = class(TForm)
    btNew: TButton;
    CsosnDataset: TXDataWebDataSet;
    CsosnDatasetcsosn_id: TStringField;
    CsosnDatasetnome: TStringField;
    CsosnDatasetexcluido: TBooleanField;
    CsosnDatasetinclusao: TDateTimeField;
    CsosnDatasetalteracao: TDateTimeField;
    CsosnDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewCsosnList: TFViewCsosnList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCsosnList }

procedure TFViewCsosnList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewCsosnList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCsosnList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewCsosnList, AElementID, Result, @AfterCreate);
end;

procedure TFViewCsosnList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewCsosnList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewCsosnList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      CsosnDataset.Connection.Model.DefaultSchema.FindEntityType(CsosnDataset.EntitySetName),
      CsosnDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewCsosnList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('csosn', 'active');
  TUtils.SetValorDicionarioClasses('tributacoes_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_tributacoes', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    CsosnDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewCsosnList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.csosn.list.pagination.info');
  btNew := TButton.Create('view.csosn.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.csosn.list.table');
  cbPageSize := TComboBox.Create('view.csosn.list.cbPageSize');
  edSearch := TEdit.Create('view.csosn.list.search');
  lcPaginator := TListControl.Create('view.csosn.list.pagination');
  CsosnDataset := TXDataWebDataSet.Create(Self);
  CsosnDatasetcsosn_id := TStringField.Create(Self);
  CsosnDatasetnome := TStringField.Create(Self);
  CsosnDatasetexcluido := TBooleanField.Create(Self);
  CsosnDatasetinclusao := TDateTimeField.Create(Self);
  CsosnDatasetalteracao := TDateTimeField.Create(Self);
  CsosnDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  CsosnDataset.BeforeLoadDFMValues;
  CsosnDatasetcsosn_id.BeforeLoadDFMValues;
  CsosnDatasetnome.BeforeLoadDFMValues;
  CsosnDatasetexcluido.BeforeLoadDFMValues;
  CsosnDatasetinclusao.BeforeLoadDFMValues;
  CsosnDatasetalteracao.BeforeLoadDFMValues;
  CsosnDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewCsosnList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'csosn_id';
      Title := 'csosn_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    CsosnDataset.SetParentComponent(Self);
    CsosnDataset.Name := 'CsosnDataset';
    CsosnDataset.EntitySetName := 'Csosn';
    CsosnDataset.Connection := DMConnection.ApiConnection;
    CsosnDataset.Left := 72;
    CsosnDataset.Top := 144;
    CsosnDatasetcsosn_id.SetParentComponent(CsosnDataset);
    CsosnDatasetcsosn_id.Name := 'CsosnDatasetcsosn_id';
    CsosnDatasetcsosn_id.FieldName := 'csosn_id';
    CsosnDatasetcsosn_id.Required := True;
    CsosnDatasetcsosn_id.Size := 255;
    CsosnDatasetnome.SetParentComponent(CsosnDataset);
    CsosnDatasetnome.Name := 'CsosnDatasetnome';
    CsosnDatasetnome.FieldName := 'nome';
    CsosnDatasetnome.Required := True;
    CsosnDatasetnome.Size := 255;
    CsosnDatasetexcluido.SetParentComponent(CsosnDataset);
    CsosnDatasetexcluido.Name := 'CsosnDatasetexcluido';
    CsosnDatasetexcluido.FieldName := 'excluido';
    CsosnDatasetinclusao.SetParentComponent(CsosnDataset);
    CsosnDatasetinclusao.Name := 'CsosnDatasetinclusao';
    CsosnDatasetinclusao.FieldName := 'inclusao';
    CsosnDatasetalteracao.SetParentComponent(CsosnDataset);
    CsosnDatasetalteracao.Name := 'CsosnDatasetalteracao';
    CsosnDatasetalteracao.FieldName := 'alteracao';
    CsosnDatasetexclusao.SetParentComponent(CsosnDataset);
    CsosnDatasetexclusao.Name := 'CsosnDatasetexclusao';
    CsosnDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := CsosnDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    CsosnDataset.AfterLoadDFMValues;
    CsosnDatasetcsosn_id.AfterLoadDFMValues;
    CsosnDatasetnome.AfterLoadDFMValues;
    CsosnDatasetexcluido.AfterLoadDFMValues;
    CsosnDatasetinclusao.AfterLoadDFMValues;
    CsosnDatasetalteracao.AfterLoadDFMValues;
    CsosnDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
